import { InputNumber } from 'antd';
import Tooltip from '../common/Tooltip';
import { useState } from "react";
import { useKeyboard } from "../../hooks";
import { navbarButtonStyle } from "../../utils/styles";

// Décimales affichées au plus, sans zéros inutiles à la fin : un ratio donne
// vite 215.00000000000003 ou 57.478070175438596.
const MAX_DISPLAYED_DECIMALS = 6;

const trimDecimals = (value) => {
  const number = Number(value);
  if (value === '' || value == null || !Number.isFinite(number)) return String(value ?? '');
  return String(parseFloat(number.toFixed(MAX_DISPLAYED_DECIMALS)));
};

export const NavbarInputNumber = ({
  tooltipContent,
  showTooltip = false,
  value,
  onChange,
  min,
  max,
  step,
  disabled = false,
  hidden,
  suffix = null,
  defaultValue = 1,
  width = 70
}) => {
  const setIsUsingKeyboard = useKeyboard(false)
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const inputNumberStyle = {
    ...navbarButtonStyle,
    width,
  }

  const input = (
    <InputNumber
      onMouseEnter={showTooltip ? () => setTooltipVisible(true) : undefined}
      onMouseLeave={showTooltip ? () => setTooltipVisible(false) : undefined}
      disabled={disabled}
      hidden={hidden}
      onFocus={() => setIsUsingKeyboard(true)}
      onBlur={() => setIsUsingKeyboard(false)}
      style={inputNumberStyle}
      // Séparateur décimal : le point. Le parseur par défaut d'antd supprime la
      // virgule (« 1,5 » deviendrait 15) ; on la convertit donc en point pour la
      // valeur (frappe ou collage), et la touche « , » insère directement un
      // « . » : antd recopie le texte brut pendant la frappe, sans formateur.
      onKeyDown={(event) => {
        if (event.key !== ',' || event.ctrlKey || event.metaKey || event.altKey) return;
        event.preventDefault();
        const field = event.target;
        field.setRangeText('.', field.selectionStart, field.selectionEnd, 'end');
        field.dispatchEvent(new Event('input', { bubbles: true }));
      }}
      parser={(text) => {
        const cleaned = suffix ? String(text).replace(suffix, '') : String(text);
        return cleaned.replace(/,/g, '.').replace(/[^\w.-]+/g, '');
      }}
      // Arrondi à l'affichage ; le texte en cours de frappe reste tel quel
      // (« 1. » ne doit pas redevenir « 1 »).
      formatter={(text, { userTyping }) => {
        const bare = suffix ? String(text).replace(suffix, '') : String(text);
        return `${userTyping ? bare : trimDecimals(bare)}${suffix ?? ''}`;
      }}
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={(value) => value ? onChange(value) : onChange(defaultValue)}
    />
  );

  // Infobulle sur demande seulement (`showTooltip`) : les champs numériques n'en
  // ont pas par défaut, `tooltipContent` reste accepté pour ceux qui l'activent.
  if (!showTooltip) return input;
  return (
    <Tooltip open={tooltipVisible} placement='bottom' mouseLeaveDelay='0' title={tooltipContent}>
      {input}
    </Tooltip>
  );
}
